import {
  bademiljoeIconUri,
  bolistCircularLogoUri,
  bolistIconImgUri,
  byggtorgetIconUri,
  coloramaCircularLogoUri,
  comfortIconUri,
  happyHomesCircularLogoUri,
  happyHomesImgUri,
  malproffCircularLogoUri,
  mestergruppenIconUri,
  xlbyggCircularLogoUri,
  xlByggIconImgUri,
} from '@assets/images';

export interface Logos {
  circularLogo: string;
  logo: string;
}

const bolistLogos: Logos = { circularLogo: bolistCircularLogoUri, logo: bolistIconImgUri };
const xlbyggLogos: Logos = { circularLogo: xlbyggCircularLogoUri, logo: xlByggIconImgUri };
const mgLogos: Logos = { circularLogo: mestergruppenIconUri, logo: mestergruppenIconUri };
const happyHomesLogos: Logos = { circularLogo: happyHomesCircularLogoUri, logo: happyHomesImgUri };
const malProffLogos: Logos = {
  circularLogo: malproffCircularLogoUri,
  logo: malproffCircularLogoUri,
};
const coloramaLogos: Logos = {
  circularLogo: coloramaCircularLogoUri,
  logo: coloramaCircularLogoUri,
};
const comfortLogos: Logos = { circularLogo: comfortIconUri, logo: comfortIconUri };
const byggtorgetLogos: Logos = { circularLogo: byggtorgetIconUri, logo: byggtorgetIconUri };
const bademiljøLogos: Logos = { circularLogo: bademiljoeIconUri, logo: bademiljoeIconUri };

export const brandLogos: Record<string, Logos> = {
  bolist: bolistLogos,
  xlbygg: xlbyggLogos,
  xlbyggsverige: xlbyggLogos,
  mestergruppenvareforsyning: mgLogos,
  happ: happyHomesLogos,
  malproff: malProffLogos,
  malp: malProffLogos,
  colo: coloramaLogos,
  comfort: comfortLogos,
  byggtorget: byggtorgetLogos,
  bademiljoe: bademiljøLogos,
};

export const brandLogo = (brandId: string): Logos => {
  return brandLogos[brandId] || mgLogos;
};
